import { isKeycloakAuth } from "@configs/authMode";
import KeycloakLogin from "./KeycloakLogin";
import LegacyLogin from "./LegacyLogin";

const Login = () => (isKeycloakAuth() ? <KeycloakLogin /> : <LegacyLogin />);

export default Login;
